import { Link, Stack, usePathname, useRouter } from 'expo-router';
import { useEffect } from 'react';
import { StyleSheet } from 'react-native';

import { ThemedText } from '@/components/ThemedText';
import { ThemedView } from '@/components/ThemedView';

export default function NotFoundScreen() {
  const pathname = usePathname();
  const router = useRouter();

  // Workaround to solve redirect reCAPTCHA issue https://github.com/invertase/react-native-firebase/issues/7258
  useEffect(() => {
    if (pathname === '/firebaseauth/link') router.back();
  }, [pathname, router]);

  return (
    <>
      <Stack.Screen options={{ title: 'Oops!' }} />
      <ThemedView style={styles.container}>
        <ThemedText type="title">This screen doesn't exist. {pathname}</ThemedText>
        <Link href="/" style={styles.link}>
          <ThemedText type="link">Go to home screen!</ThemedText>
        </Link>
      </ThemedView>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20
  },

  link: {
    marginTop: 15,
    paddingVertical: 15
  }
});
